import styled from '@emotion/styled'
import { Spin } from 'antd'

export const StyledSpin = styled(Spin)`
  z-index: 20;
`
